import axios from "axios";
import auth from "./auth";

const api = axios.create({
  baseURL: "/api",
});

api.interceptors.request.use(async (config) => {
  const bearerToken = await auth.clientApplication.acquireTokenSilent([auth.config.clientId]).then(
    (token) => token,
    () => auth.clientApplication.acquireTokenPopup([auth.config.clientId]).then((token) => token)
  );
  const newConfig = config;
  newConfig.headers.Authorization = `Bearer ${bearerToken}`;
  return newConfig;
});

export default api;
